var _defs, _path, _path2, _path3, _circle, _g, _g2, _g3, _path4, _g4, _g5, _g6, _g7, _path5, _g8, _path6, _path7, _g9, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTitleImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 214.76 100.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-24,.cls-3,.cls-9{fill:#e6e6e6;}.cls-1,.cls-4{opacity:0.31;}.cls-16,.cls-17,.cls-2{opacity:0.36;}.cls-20,.cls-21,.cls-3{opacity:0.4;}.cls-16,.cls-20,.cls-4{fill:#ccc;}.cls-5{opacity:0.53;}.cls-18,.cls-6{fill:#f2f2f2;}.cls-13,.cls-14,.cls-15,.cls-19,.cls-23,.cls-24,.cls-25,.cls-6,.cls-9{stroke:#fff;}.cls-10,.cls-13,.cls-14,.cls-15,.cls-19,.cls-23,.cls-24,.cls-25,.cls-6,.cls-9{stroke-miterlimit:10;}.cls-7{font-size:17.64px;font-family:CircularStd-Bold, Circular Std;font-weight:700;}.cls-10,.cls-21,.cls-7{fill:gray;}.cls-8{opacity:0.46;}.cls-10{stroke:#e6e6e6;}.cls-11,.cls-14{fill:#b3b3b3;}.cls-12{opacity:0.62;}.cls-13,.cls-23{fill:#999;}.cls-14,.cls-19{stroke-width:0.5px;}.cls-15{fill:none;}.cls-15,.cls-23,.cls-24,.cls-25{stroke-width:0.25px;}.cls-19{fill:#d1d4d4;}.cls-22{opacity:0.82;}.cls-25{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M196.15,92.16l.65-.06a4.94,4.94,0,0,1,2-.26c.85.06,1.7.09,2.54.14s1.86.07,2.78.14c1.66.06,3.32.11,5,.13,8.83-.32,17.58-1.12,26.36-.4a31.19,31.19,0,1,0-39.33.31Z",
    transform: "translate(-184.43 0.02)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.31,0c-5.05.1-10.06.75-15.11.7A4.94,4.94,0,0,1,278.71,0,4.83,4.83,0,0,1,277,.32c-2.95,0-5.9-.15-8.85-.31h0A5.14,5.14,0,0,1,266,.1a14.07,14.07,0,0,1-3,0c-.14,0-.26,0-.4-.06a5.58,5.58,0,0,1-1.4.18c-5.28,0-10.56-.11-15.84-.12a3.91,3.91,0,0,1-.49,0A32.73,32.73,0,1,0,296.31,0Z",
    transform: "translate(-184.43 0.02)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M343.37,6.22a55.71,55.71,0,0,0-55.81,55.61,55.09,55.09,0,0,0,8.9,30,10.23,10.23,0,0,1,3.7-.1c-1-.16,1.48.05,1.81.05.88,0,1.76,0,2.64-.07,1.89-.09,3.77-.23,5.65-.25a2.28,2.28,0,0,1,.26,0c2.58-.13,5.17-.22,7.75-.24,4.37,0,8.72.22,13.08.22a41.27,41.27,0,0,1,4.36.32,6.8,6.8,0,0,1,1.35-.14h4a7,7,0,0,1,1.64-.18c.5,0,1,0,1.5,0a3.84,3.84,0,0,1,.36-.14,6,6,0,0,1,2.47-.24,9.43,9.43,0,0,1,1.67-.22,5.76,5.76,0,0,1,2.61.49,8,8,0,0,1,2.83-.49,7.91,7.91,0,0,1,3.49.76c3.52-.09,7-.19,10.56-.2h.38c7.29,0,14.59.14,21.88.17a55.08,55.08,0,0,0,8.76-29.81A55.72,55.72,0,0,0,343.37,6.22Z",
    transform: "translate(-184.43 0.02)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 31.22,
    cy: 67.82,
    r: 23.45
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M231.91,91.64c1.42.06,2.83.15,4.25.27l4.91,0a8.17,8.17,0,1,0-9.16-.22Z",
    transform: "translate(-184.43 0.02)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(46.93 89.63) rotate(0.14)"
  }, "+"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 31.21,
    cy: 69.26,
    r: 14.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M229.75,71.59c-3.4,2.93-6.87,3.33-8,2s0-4,.13-4.39c-1.54-.75-1.86-1.38-1.86-1.82,0-1,1.54-1.23,2.47-3.25.25-.55.28-.84.64-1.11.78-.61,1.69,0,2.47-.4.49-.24,1-.92,1.12-3a12.4,12.4,0,0,1,1,1.34,13.16,13.16,0,0,1,2.05,5.32A15,15,0,0,1,229.75,71.59Z",
    transform: "translate(-184.43 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M206,80c4.48.3,7.5-1.47,7.67-3.19s-2.38-3.22-2.74-3.44c.78-1.52.65-2.22.4-2.57-.58-.79-2-.06-3.93-1.12-.53-.28-.73-.5-1.18-.5-1,0-1.36,1-2.21,1.16-.54.1-1.39-.11-2.71-1.74a12.16,12.16,0,0,0,0,1.69,13.19,13.19,0,0,0,1.55,5.5A15.25,15.25,0,0,0,206,80Z",
    transform: "translate(-184.43 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M212.59,60.57a5.2,5.2,0,0,1-1.76,4.14,4.76,4.76,0,0,1-4.16,1,4.24,4.24,0,0,1-2-1.32c0-1-.09-2.23-.71-2.46-.84-.32-2.07,1.47-2.23,1.34s1.45-3.81,5.1-6.27c1.61-1.08,3.15-2.12,4.94-1.66a5.34,5.34,0,0,1,3.18,3Z",
    transform: "translate(-184.43 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M223.5,81.34a11.22,11.22,0,0,1-3.72,1.77,8.47,8.47,0,0,1-4.06.23,7.35,7.35,0,0,1-2.2-.87,2,2,0,0,1-1.22-1,1.8,1.8,0,0,1-.15-1.51c.53-1,2.52-.44,2.79-1.19.18-.53-.73-1-.56-1.59s1.51-1,2.47-.79c2.38.41,3.29,4,3.33,4.14Z",
    transform: "translate(-184.43 0.02)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M220.44,46.54a15,15,0,0,0-3.66,2.14,25.06,25.06,0,0,0-3.35,3.47h0A32.28,32.28,0,0,0,209,50.92a16.83,16.83,0,0,0-4.67-.15L202.45,46l17-5Z",
    transform: "translate(-184.43 0.02)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "38.98 40.43 26.5 47.72 14.59 47.65 27.07 40.36 38.98 40.43"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 26.58,
    y1: 43.63,
    x2: 38.92,
    y2: 40.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 39.94,
    y1: 43.72,
    x2: 38.92,
    y2: 40.31
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M277.77.27a6.36,6.36,0,0,1-.77,0c-2.95,0-5.89-.16-8.83-.31h0A5.1,5.1,0,0,1,266,.1a13.88,13.88,0,0,1-3,0,20.92,20.92,0,1,0,14.78.19Z",
    transform: "translate(-184.43 0.02)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 72.23,
    y: 8.51,
    width: 26.9,
    height: 19.25,
    rx: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 73.15,
    y: 9.59,
    width: 24.81,
    height: 17.1,
    rx: 2.07
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "icon_12",
    "data-name": "icon 12",
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M255.41,16.08l9.78-5.48a.72.72,0,0,0,.28-1l-3.42-6.1a.73.73,0,0,0-1-.28l-3,1.71-6.78,3.79a.73.73,0,0,0-.28,1l3.41,6.08A.72.72,0,0,0,255.41,16.08Z",
    transform: "translate(-184.43 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M263.62,11.25l-1.13,2.16a.72.72,0,0,1-1.28,0h0a.73.73,0,0,0-1-.28l-4.91,2.75a.72.72,0,0,1-1-.28l-3.41-6.08a.72.72,0,0,1,.28-1L258,4.75l3-1.7a.73.73,0,0,1,1,.27l3.42,6.11a.73.73,0,0,1-.28,1l-1.47.83",
    transform: "translate(-184.43 0.02)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 72.06,
    y1: 10.93,
    x2: 77.58,
    y2: 7.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 73.11,
    y1: 12.8,
    x2: 78.63,
    y2: 9.71
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "icon_07",
    "data-name": "icon 07"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 86.17,
    cy: 16.28,
    rx: 3.54,
    ry: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M274.72,25.12a4.23,4.23,0,1,0-8.46,0",
    transform: "translate(-184.43 0.02)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "icon_12-2",
    "data-name": "icon 12",
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M278.13,19.71l11.2-.45a.73.73,0,0,0,.7-.76l-.28-7a.73.73,0,0,0-.77-.7l-3.43.17-7.76.31a.73.73,0,0,0-.7.76l.28,7A.74.74,0,0,0,278.13,19.71Z",
    transform: "translate(-184.43 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M287.64,19.12l-2,1.42A.74.74,0,0,1,284.5,20h0a.73.73,0,0,0-.76-.7l-5.62.23a.72.72,0,0,1-.75-.7l-.28-7a.73.73,0,0,1,.7-.76l7.75-.31L289,10.6a.72.72,0,0,1,.76.7l.28,7a.73.73,0,0,1-.7.76l-1.68.07",
    transform: "translate(-184.43 0.02)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 97.01,
    y1: 15.6,
    x2: 103.34,
    y2: 15.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 97.09,
    y1: 17.75,
    x2: 103.42,
    y2: 17.5
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M343.85,20.75a42.69,42.69,0,0,0-32.43,70.7c2.28-.11,4.57-.18,6.85-.2,4.37,0,8.72.22,13.08.22a41.27,41.27,0,0,1,4.36.32,6.8,6.8,0,0,1,1.35-.14h4a7,7,0,0,1,1.64-.18c.5,0,1,0,1.5,0a3.84,3.84,0,0,1,.36-.14,6,6,0,0,1,2.47-.24,9.43,9.43,0,0,1,1.67-.22,5.76,5.76,0,0,1,2.61.49,8,8,0,0,1,2.83-.49,7.91,7.91,0,0,1,3.49.76c3.52-.09,7-.19,10.56-.2h.38c2.55,0,5.09,0,7.64.06a42.37,42.37,0,0,0,10.58-28A42.83,42.83,0,0,0,343.85,20.75Z",
    transform: "translate(-184.43 0.02)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "icon_07-2",
    "data-name": "icon 07"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 159.42,
    cy: 51.53,
    rx: 16.18,
    ry: 16.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M343.37,71.81c-10.49,0-19,8.69-19.32,19.52,2.43.06,4.86.14,7.3.14a38.77,38.77,0,0,1,4.36.32,6.88,6.88,0,0,1,1.35-.14h4a7,7,0,0,1,1.64-.18c.5,0,1,0,1.5,0a3.84,3.84,0,0,1,.36-.14,6,6,0,0,1,2.47-.24,9.43,9.43,0,0,1,1.67-.22,5.76,5.76,0,0,1,2.61.49,8,8,0,0,1,2.83-.49,7.79,7.79,0,0,1,3.5.77l5.09-.13C362.51,80.61,353.94,71.81,343.37,71.81Z",
    transform: "translate(-184.43 0.02)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M359.77,54.42c-1-.77-2.56-2-4.38-3.66-4.06-3.67-4.39-4.76-6.22-5.27-2.74-.77-3.3,1.3-8.4,1.86-4.25.46-5.54-.79-8.4.31a10.32,10.32,0,0,0-4.69,3.85,13.83,13.83,0,0,1,.64-8.19,14.14,14.14,0,0,1,5.91-6.83A31.89,31.89,0,0,1,349.15,36a31.17,31.17,0,0,1,8.73,3.28,23.33,23.33,0,0,1,1.89,15.13Z",
    transform: "translate(-184.43 0.02)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M283.5,3.38",
    transform: "translate(-184.43 0.02)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M360.1,46.24a29.65,29.65,0,0,0-8,2.31,48.42,48.42,0,0,0-8.06,5h0a64.11,64.11,0,0,0-7.87-4.47,33.53,33.53,0,0,0-8.84-2.51l-1.28-9.92,34.81-1.41Z",
    transform: "translate(-184.43 0.02)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "184.29 36.05 157 43.89 134.32 38.05 161.62 30.2 184.29 36.05"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 159.11,
    y1: 36.17,
    x2: 184.23,
    y2: 35.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 184.53,
    y1: 42.75,
    x2: 184.23,
    y2: 35.79
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M365.44,70.6l-2.75-2.08a1.61,1.61,0,0,0-2.26.31l-16.79,22a1.25,1.25,0,0,0-.24.6l.75,0a3.12,3.12,0,0,1,.39-.15,6,6,0,0,1,2.47-.24,9.43,9.43,0,0,1,1.67-.22,5.94,5.94,0,0,1,2.65.5,4.28,4.28,0,0,1,.43-.17l14-18.38A1.61,1.61,0,0,0,365.44,70.6Z",
    transform: "translate(-184.43 0.02)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M139.22,108.21",
    transform: "translate(-184.43 0.02)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleImage);
export default __webpack_public_path__ + "static/media/TitleImage.1142ee2a2981ae1bdca0cea10f05714e.svg";
export { ForwardRef as ReactComponent };